<template>
	<el-dialog title="选择项目部门" width="725px" class="bindingPer" :visible.sync="isShow" append-to-body @close="close" :close-on-click-modal="false">
		<div class="bm body-info" ref="bodyinfo" v-loading="loading">
			<div class="bm-f1 choose-box bm bm-ver">
				<div class="org-type-box bm bm-ac">
					<div class="org-type-box-label">组织架构</div>
					<div class="bm-f1">
						<el-select v-model="typeSection" style="width: 100%;" size="small" @change="chooseOrgType" placeholder="请选择">
							<template v-for="item in typeOptions">
								<el-option
								v-if="item.enable == '1'"
								:key="item.classifyCode"
								:label="item.classifyDesc"
								:value="item.classifyCode">
								</el-option>
							</template>
						</el-select>
					</div>
				</div>
				<div class="search-box">
					<el-input
						placeholder="请输入内容"
						prefix-icon="el-icon-search"
						size="small"
						clearable
						v-model="searchStr">
					</el-input>
					<div class="search-show" v-if="searchConfig.show" :class="{'deptAndPer bm bm-ver': classSection == '2'}" ref="searchshow" v-loading="searchLoading">
						<template v-if="classSection == '0'">
							<template v-if="searchData.length > 0">
								<template v-for="(sData, index) in searchData">
									<div class="bm search-section-0" :key="index">
										<div class="check">
											<el-checkbox v-model="sData.checked" @change="checked =>chooseZws(checked, sData)"></el-checkbox>
										</div>
										<div class="bm-f1 txt">{{sData.jobName}}({{sData.num}})</div>
									</div>
								</template>
							</template>
							<template v-if="searchData.length == 0">
								<div class="emtry">{{searchConfig.emtry}}</div>
							</template>
						</template>
						<template v-if="classSection == '2'">
							<div class="deptBox cBox bm-f1 bm bm-ver" v-if="searchDeptData && chooseType == 'dept'">
								<div class="t">部门列表</div>
								<div class="deptScroll bm-f1">
									<template v-for="(d, index) in searchDeptData">
										<div class="comCol bm" :class="{'on': d.checked}" :key="index" @click="chooseDepts(index, d)">
											<div class="bm-f1">{{d.departHierarchy}}</div>
											<div class="arrow"></div>
										</div>
									</template>
									<div class="moreClick" v-if="searchDoublePageConfig.deptShow" @click="moreDept">
										查看更多相关部门
									</div>
								</div>
							</div>
							<div class="perBox cBox bm-f1 bm bm-ver" v-if="searchPerData && chooseType == 'per'">
								<div class="t">人员列表</div>
								<div class="perScroll bm-f1">
									<template v-for="(p, index) in searchPerData">
										<div class="comCol" :class="{'on': p.checked}" :key="index" @click="choosePers(index, p)">
											<div>{{p.personName}}</div>
											<div class="bm">
												<div class="bm-f1">{{p.hierarchy}}</div>
												<div class="arrow"></div>
											</div>
										</div>
									</template>
									<div class="moreClick" v-if="searchDoublePageConfig.perShow" @click="morePer">
										查看更多相关人员
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="choose-type bm bm-ac">
					<div class="choose-type-title">分类查找</div>
					<div class="bm-f1 bm">
						<template v-for="oClass in classType">
							<div class="bm-f1 choose-type-btn" :key="oClass.id" v-if="oClass.show" :class="{'on':classSection == oClass.id}" @click="tabFunc(oClass.id)">{{oClass.label}}</div>
						</template>
					</div>
				</div>
				<div class="choose-info bm-f1" ref="zw" v-show="classSection == '0'">
					<template v-for="(zwlist, index) in zwData">
						<div class="choose-col bm" :key="index">
							<div class="check">
								<el-checkbox v-model="zwlist.checked" @change="checked => chooseZw(checked, index, zwlist)"></el-checkbox>
							</div>
							<div class="bm-f1 txt">{{zwlist.jobName}}({{zwlist.num}})</div>
						</div>
					</template>
				</div>
				<div class="choose-info bm-f1" v-show="classSection == '1'">
					<template v-for="(listLb, index) in lbData">
						<div class="choose-col bm" :key="index">
							<div class="check">
								<el-checkbox v-model="listLb.checked" @change="checked => chooseLb(checked, listLb)"></el-checkbox>
							</div>
							<div class="bm-f1 txt">{{listLb.personType}}类({{listLb.num}})</div>
						</div>
					</template>
				</div>
				<div class="router-box" v-if="classSection == '2'">
					<template v-for="(router, index) in routeList">
						<template v-if="index < (routeList.length - 1)">
							<span :key="index" @click="toBack(index, router)">{{router.name}}</span> /
						</template>
						<template v-else>
							{{router.name}}
						</template>
					</template>
					<!-- <span>正大天晴</span> / 信息中心 -->
				</div>
				<div class="choose-info bm-f1" ref="zzzx" v-show="classSection == '2'">
					<template v-for="(zzList, index) in zzzxData">
						<div class="dept-box scroll-box bm" :key="index" v-if="zzList.chooseType == 'dept'">
							<div class="check-box">
								<el-checkbox v-if="chooseType == 'dept'" v-model="zzList.checked" @change="checked =>chooseBm(checked, zzList)" :disabled="isDisabled(zzList.departCode, 'dept')"></el-checkbox>
							</div>
							<div class="bm-f1 dept-name com-div">{{zzList.deptName}}({{zzList.deptNum}})</div>
							<div class="next-box" @click="toNext(zzList)">
								<i></i>
								<span>下级</span>
							</div>
						</div>
						<div :key="index" class="per-box scroll-box bm bm-ac" v-if="zzList.chooseType == 'per' && chooseType == 'per'">
							<div class="check-box">
								<el-checkbox v-model="zzList.checked" @change="checked =>chooseRy(checked, zzList)" :disabled="isDisabled(zzList.personCode, 'per')"></el-checkbox>
							</div>
							<div class="bm-f1 bm com-div">
								<div class="pic-box"><div class="pic">{{zzList.personName | picStr}}</div></div>
								<div class="bm-f1">
									<div class="name">{{zzList.personName}}</div>
									<div class="job">{{zzList.jobName}}</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
			<div class="bm-f1 show-box bm bm-ver">
				<div class="title bm bm-ac">
					<div class="bm-f1">已选：</div>
					<div v-if="clear"><el-button @click="clearAll" size="small">清空</el-button></div>
				</div>
				<div class="show-block bm-f1">
					<div class="zw">
						<template v-for="(ozw, index) in zwSection">
							<span :key="index" class="block">{{ozw.jobName}}<template v-if="countShow">({{ozw.num}})</template> <i class="el-icon-close" @click="removeZw(ozw)"></i></span>
						</template>
					</div>
					<div class="lb">
						<template v-for="(olb, index) in lbSection">
							<span :key="index" class="block">{{olb.personType}}类<template v-if="countShow">({{olb.num}})</template> <i class="el-icon-close" @click="removeLb(olb)"></i></span>
						</template>
					</div>
					<div class="_bm">
						<template v-for="(obm, index) in bmSection">
							<span :key="index" class="block" :disabled="obm.disabled"><em>{{obm.deptName}}<template v-if="countShow">({{obm.deptNum}})</template></em> <i v-if="!obm.disabled" class="el-icon-close" @click="removeBm(obm)"></i></span>
						</template>
					</div>
					<div class="ry">
						<template v-for="(ory, index) in rySection">
							<span class="block bm" :key="index">
								<i class="bm-f1">
									<b class="name">{{ory.personName}}</b>
									<b class="deptName" v-if="ory.jobName">{{ory.jobName}}</b>
								</i>
								<i class="el-icon-close" @click="removeRy(ory)"></i>
								<!-- <em>{{ory.personName}}</em> <i class="el-icon-close" @click="removeBm(obm)"></i>
								<div class="dept">{{ory.directDeptName}}</div> -->
							</span>
						</template>
					</div>
				</div>
				<div class="ofooter">
					<el-button @click="close">取消</el-button>
					<el-button type="primary" @click="callback">确定<span v-if="total > 0 && countShow">({{total}})</span></el-button>
				</div>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import * as bindingApi from "@/services/binding.js";
export default {
	props: {
		show: {
			type: Boolean
		},
		section: {
			type: Object
		},
		outPerShow: {
			type: Boolean,
			default: false
		},
		clear: {
			type: Boolean,
			default: false
		},
		defaultClass: {
			type: String
		},
		isAdmin: {
			type: Array
		},
		countShow: {
			type: Boolean,
			default: true
		},
		customJson: {
			type: Object
		},
		infinite: { //true 多选, false单选
			type: Boolean,
			default: true
		},
		chooseType: { // dept 选部门 per选人
			type: String,
			default: "dept"
		}
	},
	data () {
		return {
			bodyHeight: 0,
			isShow: this.show,
			loading: false,
			searchLoading: false,
			classSection: "2",
			classType: [
				{ label: "职务", id: "0", show: false},
				{ label: "人员类别", id: "1", show: false},
				{ label: "部门/人员", id: "2", show: true},
				{ label: "外部人员", id: "3", show: this.outPerShow}
			],
			searchStr: "",
			zwPage: {
				num: 1,
				size: 100,
				lock: false,
				load: true
			},
			routeList: [{ "id": "", "name": "正大天晴" }],
			zwData: [],
			lbData: [],
			zzzxData: [],
			zwSection: [],
			lbSection: [],
			bmSection: [],
			rySection: [],
			timeoutId: null,
			searchConfig: {
				show: false,
				page: 1,
				size: 30,
				emtry: "",
				lock: false,
				load: true
			},
			searchData: [],
			searchDoublePageConfig: {
				deptPage: 1,
				perPage: 1,
				size: 10,
				deptShow: false,
				perShow: false
			},
			searchDeptData: [],
			searchPerData: [],
			typeOptions: [],
			typeSection: "",
			defaultAdmin: ""
		}
	},
	methods: {
		tabFunc (id) {
			this.classSection = id;
		},
		chooseZw (status, index, obj) {
			if (status) {
				this.zwSection.push(obj);
			} else {
				this.zwSection.forEach((res, i) => {
					if (res.jobCode == obj.jobCode) {
						this.zwSection.splice(i, 1);
					}
				});
			}
		},
		chooseZws (status, obj) {
			if (status) {
				this.zwSection.push(obj);
				this.zwData.forEach((res) => {
					if (res.jobCode == obj.jobCode) {
						res.checked = true;
					}
				});
			} else {
				this.zwSection.forEach((res, i) => {
					if (res.jobCode == obj.jobCode) {
						this.zwSection.splice(i, 1);
					}
				});
				this.zwData.forEach((res) => {
					if (res.jobCode == obj.jobCode) {
						res.checked = false;
					}
				});
			}
		},
		removeZw (obj) {
			this.zwSection.splice(this.zwSection.indexOf(obj), 1);
			this.zwData.forEach((res) => {
				if (res.jobCode == obj.jobCode) {
					res.checked = false;
				}
			});
			if (this.classSection == "0") {
				this.searchData.forEach((res) => {
					if (res.jobCode == obj.jobCode) {
						res.checked = false;
					}
				});
			}
		},
		chooseLb (status, obj) {
			if (status) {
				this.lbSection.push(obj);
			} else {
				this.lbSection.forEach((res, i) => {
					if (res.personType == obj.personType) {
						this.lbSection.splice(i, 1);
					}
				});
			}
		},
		removeLb (obj) {
			this.lbSection.splice(this.lbSection.indexOf(obj), 1);
			this.lbData.forEach((res) => {
				if (res.personType == obj.personType) {
					res.checked = false;
				}
			});
		},
		chooseBm (status, obj) {
			if (status) {
				this.bmSection.push(obj);
			} else {
				this.bmSection.forEach((res, i) => {
					if (res.departCode == obj.departCode) {
						this.bmSection.splice(i, 1);
					}
				});
			}
		},
		removeBm (obj) {
			this.bmSection.splice(this.bmSection.indexOf(obj), 1);
			this.zzzxData.forEach((res) => {
				if (res.chooseType == "dept") {
					if (res.departCode == obj.departCode) {
						res.checked = false;
					}
				}
			});
			if (this.classSection == "2") {
				this.searchDeptData.forEach((res) => {
					if (res.departCode == obj.departCode) {
						res.checked = false;
					}
				});
			}
		},
		chooseRy (status, obj) {
			if (status) {
				this.rySection.push(obj);
			} else {
				this.rySection.forEach((res, i) => {
					if (res.personCode == obj.personCode) {
						this.rySection.splice(i, 1);
					}
				});
			}
		},
		choosePers (index, obj) {
			if (!this.searchPerData[index].checked) {
				if (!this.infinite) {
					this.rySection = [];
					this.searchPerData.forEach((res) => {
						res.checked = false;
					});
					this.zzzxData.forEach((res) => {
						if (res.chooseType == "per") {
							res.checked = false;
						}
					});
				}
				this.searchPerData[index].checked = true;
				this.rySection.push(obj);
				this.zzzxData.forEach((res) => {
					if (res.chooseType == "per") {
						if (res.personCode == obj.personCode) {
							res.checked = true;
						}
					}
				});
			} else {
				this.searchPerData[index].checked = false;
				this.rySection.forEach((res, i) => {
					if (res.personCode == obj.personCode) {
						this.rySection.splice(i, 1);
					}
				});
				this.zzzxData.forEach((res) => {
					if (res.chooseType == "per") {
						if (res.personCode == obj.personCode) {
							res.checked = false;
						}
					}
				});
			}
		},
		chooseDepts (index, obj) {
			if (!this.searchDeptData[index].checked) {
				if (!this.infinite) {
					this.bmSection = [];
					this.searchDeptData.forEach((res) => {
						res.checked = false;
					});
					this.zzzxData.forEach((res) => {
						if (res.chooseType == "dept") {
							res.checked = false;
						}
					});
				}
				this.searchDeptData[index].checked = true;
				this.bmSection.push(obj);
				this.zzzxData.forEach((res) => {
					if (res.chooseType == "dept") {
						if (res.departCode == obj.departCode) {
							res.checked = true;
						}
					}
				});
			} else {
				this.searchDeptData[index].checked = false;
				this.bmSection.forEach((res, i) => {
					if (res.departCode == obj.departCode) {
						this.bmSection.splice(i, 1);
					}
				});
				this.zzzxData.forEach((res) => {
					if (res.chooseType == "dept") {
						if (res.departCode == obj.departCode) {
							res.checked = false;
						}
					}
				});
			}
		},
		removeRy (obj) {
			this.rySection.splice(this.rySection.indexOf(obj), 1);
			this.zzzxData.forEach((res) => {
				if (res.chooseType == "per") {
					if (res.personCode == obj.personCode) {
						res.checked = false;
					}
				}
			});
			if (this.classSection == "2") {
				this.searchPerData.forEach((res) => {
					if (res.personCode == obj.personCode) {
						res.checked = false;
					}
				});
			}
		},
		moreDept () {
			this.loading = true;
			this.searchDoublePageConfig.deptPage += 1;
			bindingApi.searchDeptAndPer({
				"classifyCode": this.typeSection,
				"keyword": this.searchStr,
				"isAdministrative": this.defaultAdmin,
				"deptPageNo": this.searchDoublePageConfig.deptPage,
				"deptPageSize": this.searchDoublePageConfig.size,
				"personPageNo": this.searchDoublePageConfig.perPage,
				"personPageSize": this.searchDoublePageConfig.size,
				"flag": this.customJson ? this.customJson.flag : ""
			}).then((res) => {
				if (res.responseData.departPage.pageData) {
					res.responseData.departPage.pageData.forEach((value) => {
						value.departCode = value.deptCode;
						value.checked = false;
					});
					this.bmSection.forEach((bm) => {
						res.responseData.departPage.pageData.forEach((value) => {
							if (bm.departCode == value.departCode) {
								value.checked = true;
							}
						});
					});
				}
				this.searchDeptData = this.searchDeptData.concat(res.responseData.departPage.pageData);
				if (this.searchDoublePageConfig.deptPage < res.responseData.departPage.totalPages) {
					this.searchDoublePageConfig.deptShow = true;
				} else {
					this.searchDoublePageConfig.deptShow = false;
				}
				this.loading = false;
			});
		},
		morePer () {
			this.loading = true;
			this.searchDoublePageConfig.perPage += 1;
			bindingApi.searchDeptAndPer({
				"classifyCode": this.typeSection,
				"keyword": this.searchStr,
				"isAdministrative": this.defaultAdmin,
				"deptPageNo": this.searchDoublePageConfig.deptPage,
				"deptPageSize": this.searchDoublePageConfig.size,
				"personPageNo": this.searchDoublePageConfig.perPage,
				"personPageSize": this.searchDoublePageConfig.size,
				"flag": this.customJson ? this.customJson.flag : ""
			}).then((res) => {
				if (res.responseData.personPage.pageData) {
					res.responseData.personPage.pageData.forEach((value) => {
						value.departCode = value.deptCode;
						value.directDeptName = value.deptName;
						value.directDeptCode = value.deptCode;
						value.positionName = value.postName;
						value.positionCode = value.postCode;
						value.jobName = value.dutyName;
						value.jobCode = value.dutyCode;
						value.checked = false;
					});
					this.rySection.forEach((ry) => {
						res.responseData.personPage.pageData.forEach((value) => {
							if (ry.personCode == value.personCode) {
								value.checked = true;
							}
						});
					});
				}
				this.searchPerData = this.searchPerData.concat(res.responseData.personPage.pageData);
				if (this.searchDoublePageConfig.perPage < res.responseData.personPage.totalPages) {
					this.searchDoublePageConfig.perShow = true;
				} else {
					this.searchDoublePageConfig.perShow = false;
				}
				this.loading = false;
			});
		},
		toNext (obj) {
			this.loading = true;
			this.$refs.zzzx.scrollTop = 0;
			bindingApi.getAllDeptPersons({
				"orgId": obj.deptId,
				"classifyCode": this.typeSection,
				"isAdministrative": this.defaultAdmin,
				"flag": this.customJson ? this.customJson.flag : ""
			}).then((res) => {
				// console.log('朱自信心', res);
				let oData = res.responseData;
				let oArr = [];
				if (this.typeSection != "3") {
					oData.deptList.forEach((res) => {
						res.chooseType = "dept";
						res.checked = false;
						oArr.push(res);
					});
					this.bmSection.forEach((val) => {
						oArr.forEach((res) => {
							if (res.chooseType == "dept") {
								if (res.departCode == val.departCode) {
									res.checked = true;
								}
							}
						});
					});
					oData.personnelList.forEach((res) => {
						res.chooseType = "per";
						res.checked = false;
						oArr.push(res);
					});
					this.rySection.forEach((val) => {
						oArr.forEach((res) => {
							if (res.chooseType == "per") {
								if (res.personCode == val.personCode) {
									res.checked = true;
								}
							}
						});
					});
					this.zzzxData = oArr;
				} else {
					oData.hr.deptList.forEach((res) => {
						res.chooseType = "dept";
						res.checked = false;
						oArr.push(res);
					});
					oData.hr.personnelList.forEach((res) => {
						res.chooseType = "per";
						res.checked = false;
						oArr.push(res);
					});
					// oData.virtual.deptList.forEach(res => {
					// 	res.chooseType = "dept";
					// 	res.deptName = res.departName;
					// 	res.checked = false;
					// 	oArr.push(res);
					// });
					// oData.virtual.personnelList.forEach(res => {
					// 	res.chooseType = "per";
					// 	res.checked = false;
					// 	oArr.push(res);
					// });
					this.bmSection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "dept") {
								if (res.departCode == rep.departCode) {
									rep.checked = true;
								}
							}
						});
					});
					this.rySection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "per") {
								if (res.personCode == rep.personCode) {
									rep.checked = true;
								}
							}
						});
					});
					this.zzzxData = oArr;
				}
				this.loading = false;
			});

			this.routeList.push({ "id": obj.deptId, "name": obj.deptName });
		},
		chooseOrgType (val) {
			// console.log(val);
			this.zwPage = {
				num: 1,
				size: 100,
				lock: false,
				load: true
			};
			this.zwData = [];
			this.loading = true;
			if (this.isAdmin.indexOf(val) > -1) {
				this.defaultAdmin = "1";
			} else {
				this.defaultAdmin = "0";
			}
			bindingApi.getCountByJob({
				"pageNo": this.zwPage.num,
				"pageSize": this.zwPage.size,
				"isAdministrativeDuty": this.defaultAdmin,
				"classifyCode": val,
				"flag": this.customJson ? this.customJson.flag : ""
			}).then((res) => {
				let oData = res.responseData.list;
				oData.forEach((res) => {
					res.checked = false;
				});
				this.zwSection.forEach((res) => {
					oData.forEach((rep) => {
						if (res.jobCode == rep.jobCode) {
							rep.checked = true;
						}
					});
				});
				this.zwData = this.zwData.concat(oData);
				if (this.zwPage.num >= res.responseData.totalPages) {
					this.zwPage.load = false;
				}
				this.zwPage.num += 1;
			});
			this.zzzxData = [];
			this.routeList = [{ "id": "", "name": "正大天晴" }];
			bindingApi.getAllDeptPersons({
				"orgId": "",
				"classifyCode": this.typeSection,
				"isAdministrative": this.defaultAdmin,
				"flag": this.customJson ? this.customJson.flag : ""
			}).then((res) => {
				// console.log('朱自信心', res);
				let oData = res.responseData;
				let oArr = [];
				if (this.typeSection != "3") {
					oData.deptList.forEach((res) => {
						res.chooseType = "dept";
						res.checked = false;
						oArr.push(res);
					});
					this.bmSection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "dept") {
								if (res.departCode == rep.departCode) {
									rep.checked = true;
								}
							}
						});
					});
					oData.personnelList.forEach((res) => {
						res.chooseType = "per";
						res.checked = false;
						oArr.push(res);
					});
					this.rySection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "per") {
								if (res.personCode == rep.personCode) {
									rep.checked = true;
								}
							}
						});
					});
					this.zzzxData = oArr;
				} else {
					oData.hr.deptList.forEach((res) => {
						res.chooseType = "dept";
						res.checked = false;
						oArr.push(res);
					});
					oData.hr.personnelList.forEach((res) => {
						res.chooseType = "per";
						res.checked = false;
						oArr.push(res);
					});
					// oData.virtual.deptList.forEach(res => {
					// 	res.chooseType = "dept";
					// 	res.deptName = res.departName;
					// 	res.checked = false;
					// 	oArr.push(res);
					// });
					// oData.virtual.personnelList.forEach(res => {
					// 	res.chooseType = "per";
					// 	res.checked = false;
					// 	oArr.push(res);
					// });
					this.bmSection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "dept") {
								if (res.departCode == rep.departCode) {
									rep.checked = true;
								}
							}
						});
					});
					this.rySection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "per") {
								if (res.personCode == rep.personCode) {
									rep.checked = true;
								}
							}
						});
					});
					this.zzzxData = oArr;
				}
			});
			this.loading = false;
			clearTimeout(this.timeoutId);
			this.searchStr = "";
			this.searchData = [];
			this.searchDeptData = [];
			this.searchPerData = [];
			this.searchConfig = {
				show: false,
				page: 1,
				size: 30,
				emtry: "",
				lock: false,
				load: true
			};
			this.searchDoublePageConfig = {
				deptPage: 1,
				perPage: 1,
				size: 10,
				deptShow: false,
				perShow: false
			};
			if (this.classSection == "0") {
				if (this.$refs.searchshow) {
					this.$refs.searchshow.removeEventListener("scroll", this.searchLoadMore);
				}
			}
		},
		toBack (index, row) {
			this.loading = true;
			this.$refs.zzzx.scrollTop = 0;
			this.routeList.splice(index + 1, this.routeList.length - index);
			bindingApi.getAllDeptPersons({
				"orgId": row.id,
				"classifyCode": this.typeSection,
				"isAdministrative": this.defaultAdmin,
				"flag": this.customJson ? this.customJson.flag : ""
			}).then((res) => {
				let oData = res.responseData;
				let oArr = [];
				if (this.typeSection != "3") {
					oData.deptList.forEach((res) => {
						res.chooseType = "dept";
						res.checked = false;
						oArr.push(res);
					});
					this.bmSection.forEach((val) => {
						oArr.forEach((res) => {
							if (res.chooseType == "dept") {
								if (res.departCode == val.departCode) {
									res.checked = true;
								}
							}
						});
					});
					oData.personnelList.forEach((res) => {
						res.chooseType = "per";
						res.checked = false;
						oArr.push(res);
					});
					this.rySection.forEach((val) => {
						oArr.forEach((res) => {
							if (res.chooseType == "per") {
								if (res.personCode == val.personCode) {
									res.checked = true;
								}
							}
						});
					});
					this.zzzxData = oArr;
				} else {
					oData.hr.deptList.forEach((res) => {
						res.chooseType = "dept";
						res.checked = false;
						oArr.push(res);
					});
					oData.hr.personnelList.forEach((res) => {
						res.chooseType = "per";
						res.checked = false;
						oArr.push(res);
					});
					// oData.virtual.deptList.forEach(res => {
					// 	res.chooseType = "dept";
					// 	res.deptName = res.departName;
					// 	res.checked = false;
					// 	oArr.push(res);
					// });
					// oData.virtual.personnelList.forEach(res => {
					// 	res.chooseType = "per";
					// 	res.checked = false;
					// 	oArr.push(res);
					// });
					this.bmSection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "dept") {
								if (res.departCode == rep.departCode) {
									rep.checked = true;
								}
							}
						});
					});
					this.rySection.forEach((res) => {
						oArr.forEach((rep) => {
							if (rep.chooseType == "per") {
								if (res.personCode == rep.personCode) {
									rep.checked = true;
								}
							}
						});
					});
					this.zzzxData = oArr;
				}
				this.loading = false;
			});
		},
		callback () {
			let callbackArr = {
				jobList: JSON.parse(JSON.stringify(this.zwSection)),
				categoryList: JSON.parse(JSON.stringify(this.lbSection)),
				deptList: JSON.parse(JSON.stringify(this.bmSection)),
				perList: JSON.parse(JSON.stringify(this.rySection))
			};
			this.reset();
			this.$emit("callback", callbackArr);
			// console.log(callbackArr);
		},
		close () {
			this.reset();
			this.$emit("cannel", false);
		},
		clearAll () {
			this.zwSection = [];
			this.lbSection = [];
			this.bmSection = [];
			this.rySection = [];

			this.zwData.forEach((res) => {
				res.checked = false;
			});
			this.lbData.forEach((res) => {
				res.checked = false;
			});
			this.zzzxData.forEach((res) => {
				res.checked = false;
			});
		},
		reset () {
			if (this.$refs.zw) {
				this.$refs.zw.removeEventListener("scroll", this.loadMore);
			}
			this.loading = false;
			this.classSection = "2";
			this.searchStr = "";
			this.zwPage = {
				num: 1,
				size: 100,
				lock: false,
				load: true
			};
			this.routeList = [{ "id": "", "name": "正大天晴" }];
			this.zwData = [];
			this.lbData = [];
			this.zzzxData = [];
			this.zwSection = [];
			this.lbSection = [];
			this.bmSection = [];
			this.rySection = [];
			this.timeoutId = null;
			this.searchConfig = {
				show: false,
				page: 1,
				size: 30,
				emtry: "",
				lock: false,
				load: true
			};
			this.searchData = [];
			this.typeOptions = [];
			this.typeSection = "";
			this.defaultAdmin = "";
		},
		isDisabled (id, type) {
			if (!this.infinite) {
				if (type == "dept" && this.bmSection.length > 0) {
					for(let i = 0; i < this.bmSection.length; i++){
						if (!this.bmSection[i].disabled) {
							if (this.bmSection[i].departCode == id) {
								return false;
							} else {
								return true;
							}
						}else{
							if (this.bmSection[i].departCode == id) {
								if (this.bmSection[i].disabled) {
									return true;
								}
							}
						}

					}

				} else if (type == "per" && this.rySection.length > 0) {
					for(let i = 0; i < this.rySection.length; i++){
						if (this.rySection[i].personCode == id) {
							return false;
						} else {
							return true;
						}
					}
				}
			}else{
				if (type == "dept" && this.bmSection.length > 0) {
					for(let i = 0; i < this.bmSection.length; i++){
						if (this.bmSection[i].departCode == id) {
							return this.bmSection[i].disabled;
						}
					}
				}
			}
		}
	},
	filters: {
		picStr (str) {
			return str.substring(str.length - 2);
		}
	},
	computed: {
		total () {
			if (this.countShow) {
				let totalNum = 0;
				this.zwSection.forEach((res) => {
					totalNum += parseInt(res.num);
				});
				this.lbSection.forEach((res) => {
					totalNum += parseInt(res.num);
				});
				this.bmSection.forEach((res) => {
					totalNum += parseInt(res.deptNum);
				});
				this.rySection.forEach((res) => {
					totalNum ++;
				});
				return totalNum;
			} else {
				return "";
			}
		}
	},
	watch: {
		show (val) {
			if (val) {
				this.loading = true;
				this.typeSection = this.defaultClass;
				if (this.isAdmin.indexOf(this.defaultClass) > -1) {
					this.defaultAdmin = "1";
				} else {
					this.defaultAdmin = "0";
				}
				// if (this.defaultClass == "4" || this.defaultClass == "6") {
				// 	this.defaultAdmin = "1";
				// } else {
				// 	this.defaultAdmin = "0";
				// }
				this.zwSection = this.section.jobList || [];
				this.lbSection = this.section.categoryList || [];
				this.bmSection = this.section.deptList || [];
				this.rySection = this.section.perList || [];
				new Promise((resolve, reject) => {
					bindingApi.getClassifyList().then((res) => {
						// console.log("getClassifyList", res);
						this.typeOptions = res.responseData;
						resolve("OK");
					});
				}).then((res) => {
					bindingApi.getCountByJob({
						"pageNo": this.zwPage.num,
						"pageSize": this.zwPage.size,
						"isAdministrativeDuty": this.defaultAdmin,
						"classifyCode": this.typeSection,
						"flag": this.customJson ? this.customJson.flag : ""
					}).then((res) => {
						let oData = res.responseData.list;
						oData.forEach((res) => {
							res.checked = false;
						});
						this.zwSection.forEach((res) => {
							oData.forEach((rep) => {
								if (res.jobCode == rep.jobCode) {
									rep.checked = true;
								}
							});
						});
						this.zwData = this.zwData.concat(oData);
						if (this.zwPage.num >= res.responseData.totalPages) {
							this.zwPage.load = false;
						}
						this.zwPage.num += 1;
					});
				}).then((res) => {
					bindingApi.getCountByPersonType({
						"flag": this.customJson ? this.customJson.flag : ""
					}).then((res) => {
						// console.log(res);
						let oData = res.responseData;
						oData.forEach((res) => {
							res.checked = false;
						});
						this.lbSection.forEach((res) => {
							oData.forEach((rep) => {
								if (res.personType == rep.personType) {
									rep.checked = true;
								}
							});
						});
						this.lbData = oData;
					});
				}).then((res) => {
					bindingApi.getAllDeptPersons({
						"orgId": "",
						"classifyCode": this.typeSection,
						"isAdministrative": this.defaultAdmin,
						"flag": this.customJson ? this.customJson.flag : ""
					}).then((res) => {
						// console.log('朱自信心', res);
						let oData = res.responseData;
						let oArr = [];
						if (this.typeSection != "3") {
							oData.deptList.forEach((res) => {
								res.chooseType = "dept";
								res.checked = false;
								oArr.push(res);
							});
							this.bmSection.forEach((res) => {
								oArr.forEach((rep) => {
									if (rep.chooseType == "dept") {
										if (res.departCode == rep.departCode) {
											rep.checked = true;
										}
									}
								});
							});
							oData.personnelList.forEach((res) => {
								res.chooseType = "per";
								res.checked = false;
								oArr.push(res);
							});
							this.rySection.forEach((res) => {
								oArr.forEach((rep) => {
									if (rep.chooseType == "per") {
										if (res.personCode == rep.personCode) {
											rep.checked = true;
										}
									}
								});
							});
							this.zzzxData = oArr;
						} else {
							oData.hr.deptList.forEach((res) => {
								res.chooseType = "dept";
								res.checked = false;
								oArr.push(res);
							});
							oData.hr.personnelList.forEach((res) => {
								res.chooseType = "per";
								res.checked = false;
								oArr.push(res);
							});
							// oData.virtual.deptList.forEach(res => {
							// 	res.chooseType = "dept";
							// 	res.deptName = res.departName;
							// 	res.checked = false;
							// 	oArr.push(res);
							// });
							// oData.virtual.personnelList.forEach(res => {
							// 	res.chooseType = "per";
							// 	res.checked = false;
							// 	oArr.push(res);
							// });
							this.bmSection.forEach((res) => {
								oArr.forEach((rep) => {
									if (rep.chooseType == "dept") {
										if (res.departCode == rep.departCode) {
											rep.checked = true;
										}
									}
								});
							});
							this.rySection.forEach((res) => {
								oArr.forEach((rep) => {
									if (rep.chooseType == "per") {
										if (res.personCode == rep.personCode) {
											rep.checked = true;
										}
									}
								});
							});
							this.zzzxData = oArr;
						}
						this.$nextTick(() => {
							this.loading = false;
						});
					});
				}).catch((e) => {
					console.log(e);
					this.loading = false;
				});

				let self = this;
				this.loadMore = function () {
					let sign = 100;
					let scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
					if (scrollDistance <= sign) {
						if (self.zwPage.load) {
							if (!self.zwPage.lock) {
								// console.log('分页');
								self.loading = true;
								self.zwPage.lock = true;
								setTimeout(() => {
									bindingApi.getCountByJob({
										"pageNo": self.zwPage.num,
										"pageSize": self.zwPage.size,
										"isAdministrativeDuty": self.defaultAdmin,
										"classifyCode": self.typeSection,
										"flag": self.customJson ? self.customJson.flag : ""
									}).then((res) => {
										let oData = res.responseData.list;
										oData.forEach((res) => {
											res.checked = false;
										});
										self.zwSection.forEach((res) => {
											oData.forEach((rep) => {
												if (res.jobCode == rep.jobCode) {
													rep.checked = true;
												}
											});
										});
										self.zwData = self.zwData.concat(oData);
										if (self.zwPage.num >= res.responseData.totalPages) {
											self.zwPage.load = false;
										}
										self.zwPage.num += 1;
										self.zwPage.lock = false;
										self.loading = false;
									});
								}, 1000);
							}
						}
					}
				}
				setTimeout(() => {
					if (this.$refs.zw) {
						this.$refs.zw.addEventListener("scroll", this.loadMore);
					}
				}, 0);
			}
			this.isShow = val;
		},
		section (val) {
			// this.zwSection = val.jobList || [];
			// this.lbSection = val.categoryList || [];
			// this.bmSection = val.deptList || [];
			// this.rySection = val.perList || [];
		},
		searchStr (str) {
			if (str != "") {
				if (this.classSection == "0") {
					clearTimeout(this.timeoutId);
					this.timeoutId = setTimeout(() => {
						this.searchData = [];
						this.searchConfig = {
							show: true,
							page: 1,
							size: 30,
							emtry: "",
							lock: false,
							load: true
						};
						this.loading = true;
						bindingApi.searchZw({
							"classifyCode": this.typeSection,
							"keyword": this.searchStr,
							"isAdministrative": this.defaultAdmin,
							"pageNo": this.searchConfig.page,
							"pageSize": this.searchConfig.size,
							"flag": this.customJson ? this.customJson.flag : ""
						}).then((res) => {
							res.responseData.pageData.forEach((val) => {
								val.checked = false;
							});
							this.zwSection.forEach((result) => {
								res.responseData.pageData.forEach((val) => {
									if (result.jobCode == val.jobCode) {
										val.checked = true;
									}
								});
							});
							this.searchData = this.searchData.concat(res.responseData.pageData);
							res.responseData.pageData.length == 0 ? this.searchConfig.emtry = "暂无数据" : this.searchConfig.emtry = "";
							if (this.searchConfig.page >= res.responseData.totalPages) {
								this.searchConfig.load = false;
							}
							this.searchConfig.page += 1;
							this.searchConfig.lock = false;
							this.loading = false;
						});
					}, 1000);
					setTimeout(() => {
						if (this.$refs.searchshow) {
							this.$refs.searchshow.addEventListener("scroll", this.searchLoadMore);
						}
					}, 0);
				} else if (this.classSection == "2") {
					clearTimeout(this.timeoutId);
					this.timeoutId = setTimeout(() => {
						this.searchDeptData = [];
						this.searchPerData = [];
						this.searchConfig.show = true;
						this.searchDoublePageConfig = {
							deptPage: 1,
							perPage: 1,
							size: 10,
							deptShow: false,
							perShow: false
						};
						this.loading = true;
						bindingApi.searchDeptAndPer({
							"classifyCode": this.typeSection,
							"keyword": this.searchStr,
							"isAdministrative": this.defaultAdmin,
							"deptPageNo": this.searchDoublePageConfig.deptPage,
							"deptPageSize": this.searchDoublePageConfig.size,
							"personPageNo": this.searchDoublePageConfig.perPage,
							"personPageSize": this.searchDoublePageConfig.size,
							"flag": this.customJson ? this.customJson.flag : ""
						}).then((res) => {
							if (res.responseData.departPage.pageData) {
								res.responseData.departPage.pageData.forEach((value) => {
									value.departCode = value.deptCode;
									value.checked = false;
								});
								this.bmSection.forEach((bm) => {
									res.responseData.departPage.pageData.forEach((value) => {
										if (bm.departCode == value.departCode) {
											value.checked = true;
										}
									});
								});
							}
							this.searchDeptData = res.responseData.departPage.pageData;
							if (this.searchDoublePageConfig.deptPage < res.responseData.departPage.totalPages) {
								this.searchDoublePageConfig.deptShow = true;
							} else {
								this.searchDoublePageConfig.deptShow = false;
							}
							if (res.responseData.personPage.pageData) {
								res.responseData.personPage.pageData.forEach((value) => {
									value.checked = false;
									value.directDeptName = value.deptName;
									value.directDeptCode = value.deptCode;
									value.positionName = value.postName;
									value.positionCode = value.postCode;
									value.jobName = value.dutyName;
									value.jobCode = value.dutyCode;
								});
								this.rySection.forEach((ry) => {
									res.responseData.personPage.pageData.forEach((value) => {
										if (ry.personCode == value.personCode) {
											value.checked = true;
										}
									});
								});
							}
							this.searchPerData = res.responseData.personPage.pageData;
							if (this.searchDoublePageConfig.perPage < res.responseData.personPage.totalPages) {
								this.searchDoublePageConfig.perShow = true;
							} else {
								this.searchDoublePageConfig.perShow = false;
							}
							this.loading = false;
						});
					}, 1000);
				}
				let self = this;
				this.searchLoadMore = function () {
					let sign = 100;
					let scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
					if (scrollDistance <= sign) {
						if (self.searchConfig.load) {
							if (!self.searchConfig.lock) {
								self.loading = true;
								self.searchConfig.lock = true;
								setTimeout(() => {
									bindingApi.searchZw({
										"classifyCode": this.typeSection,
										"keyword": self.searchStr,
										"isAdministrative": this.defaultAdmin,
										"pageNo": self.searchConfig.page,
										"pageSize": self.searchConfig.size,
										"flag": self.customJson ? self.customJson.flag : ""
									}).then((res) => {
										res.responseData.pageData.forEach((val) => {
											val.checked = false;
										});
										self.zwSection.forEach((result) => {
											res.responseData.pageData.forEach((val) => {
												if (result.jobCode == val.jobCode) {
													val.checked = true;
												}
											});
										});
										self.searchData = self.searchData.concat(res.responseData.pageData);
										res.responseData.pageData.length == 0 ? self.searchConfig.emtry = "暂无数据" : self.searchConfig.emtry = "";
										if (self.searchConfig.page >= res.responseData.totalPages) {
											self.searchConfig.load = false;
										}
										self.searchConfig.page += 1;
										self.searchConfig.lock = false;
										self.loading = false;
									});
								}, 1000);
							}
						}
					}
				}
			} else {
				clearTimeout(this.timeoutId);
				this.searchData = [];
				this.searchDeptData = [];
				this.searchPerData = [];
				this.loading = false;
				this.searchConfig = {
					show: false,
					page: 1,
					size: 30,
					emtry: "",
					lock: false,
					load: true
				};
				this.searchDoublePageConfig = {
					deptPage: 1,
					perPage: 1,
					size: 10,
					deptShow: false,
					perShow: false
				};
				if (this.classSection == "0") {
					if (this.$refs.searchshow) {
						this.$refs.searchshow.removeEventListener("scroll", this.searchLoadMore);
					}
				}
			}
		}
	}
}
</script>
<style lang="scss">
.bindingPer{
	.el-dialog__body{
		padding: 0;
		border-top: 1px solid #dcdfe5;
	}
	.body-info{
		height: 65vh;
	}
	.org-type-box{
		margin: 10px 0;
		.org-type-box-label{
			font-size: 14px;
			color: #323232;
			margin-right: 10px;
		}
	}
	.choose-box{
		padding: 0 20px;
		position: relative;
		box-sizing: border-box;
		overflow: hidden;
		width: 362.5px;
		&:after{
			content: '';
			display: block;
			width: 1px;
			height: 100%;
			position: absolute;
			right: 0;
			top: 0;
			background-color: #dcdfe5;
		}
		.search-box{
			margin: 10px 0 20px 0;
			position: relative;
			.emtry{
				text-align: center;
			}
			.search{
				width: 100%;
			}
			.search-show{
				height: calc(65vh - 94px);
				overflow: auto;
				position: absolute;
				left: 0;
				right: 0;
				top: 100%;
				border: 1px solid #dcdfe5;
				z-index: 60;
				background-color: white;
				padding: 10px;
				box-sizing: border-box;
				.search-section-0{
					margin-bottom: 5px;
					&:last-child{
						margin-bottom: 0;
					}
					.txt {
						font-size: 14px;
						color: #323232;
						margin-left: 10px;
					}
				}
			}
			.deptAndPer{
				padding: 0;
				background-color: #f0f2f5;
				.cBox{
					background-color: white;
					&:first-child{
						margin-bottom: 5px;
						border-bottom: 1px solid #ebedf4;
					}
					.t{
						padding: 10px 20px;
						line-height: 100%;
						font-size: 12px;
						color: #919191;
						border-bottom: 1px solid #ebedf4;
					}
					.comCol{
						color: #323232;
						font-size: 12px;
						padding: 10px 20px;
						border-bottom: 1px solid #ebedf4;
						cursor: pointer;
						&.on{
							color: #409EFF;
						}
					}
					.deptScroll,.perScroll{
						overflow: auto;
					}
					.moreClick{
						color: #409EFF;
						font-size: 12px;
						padding: 10px 20px;
						cursor: pointer;
					}
				}
			}
		}
		.choose-type{
			color: #969696;
			font-size: 12px;
			.choose-type-btn{
				height: 24px;
				line-height: 24px;
				border-radius: 4px;
				border: solid 1px #dddfe6;
				text-align: center;
				margin-left: 8px;
				cursor: pointer;
				&.on{
					background-color: #409eff17;
					border: solid 1px #409eff;
					color: #409eff;
				}
			}
		}
		.router-box{
			margin-top: 15px;
			font-size: 12px;
			color: #646464;
			span{
				color: #323232;
				cursor: pointer;
			}
		}
		.choose-info{
			margin-top: 25px;
			overflow: auto;
			.choose-col{
				margin-bottom: 25px;
				.txt{
					font-size: 14px;
					color: #323232;
					margin-left: 10px;
				}
			}
			.scroll-box{
				font-size: 14px;
				// margin: 0 20px 20px 20px;
				margin-bottom: 20px;
				box-sizing: border-box;
				line-height: 100%;
				.next-box{
					cursor: pointer;
					box-sizing: border-box;
					font-size: 0;
					margin-right: 10px;
					span{
						color: #a8a9ab;
						font-size: 14px;
						vertical-align: middle;
					}
					i{
						display: inline-block;
						width: 14px;
						height: 14px;
						background: url(./imgs/btn_next.svg) no-repeat center center;
						background-size: 100% 100%;
						vertical-align: middle;
						margin-left: 10px;
					}
				}
				.com-div{
					padding-left: 10px;
					box-sizing: border-box;
				}
				.pic-box{
					margin-right: 10px;
					.pic{
						width: 30px;
						height: 30px;
						border-radius: 50%;
						background-color: #409EFF;
						font-size: 12px;
						text-align: center;
						line-height: 30px;
						color: white;
					}
				}
				.name{
					margin-bottom: 5px;
				}
				.job{
					color: #aaaaaa;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					word-break: break-all;
					width: 220px;
				}
			}
			.dept-box{
				.dept-name{
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					word-break: break-all;
					box-sizing: border-box;
					padding-right: 10px;
					position: relative;
					&:after{
						content: '';
						display: block;
						width: 1px;
						height: 100%;
						background-color: #ededed;
						position: absolute;
						right: 0;
						top: 0;
					}
				}
			}
		}
	}
	.show-box{
		box-sizing: border-box;
		padding: 20px;
		width: 362.5px;
		.title{
			color: #969696;
			font-size: 14px;
			margin-bottom: 18px;
		}
		.show-block{
			overflow: auto;
			margin-bottom: 20px;
			.block{
				display: inline-block;
				background-color: #f0f2f5;
				border-radius: 4px;
				color: #323232;
				font-size: 14px;
				padding: 8px 12px;
				margin-bottom: 10px;
				margin-right: 10px;
				line-height: 100%;
				i{
					display: inline-block;
					b{
						font-weight: normal;
						font-style: normal;
						display: block;
					}
				}
				em{
					display: inline-block;
					max-width: 90px;
					font-weight: normal;
					font-style: normal;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				i{
					cursor: pointer;
				}
			}
			.ry{
				.block{
					.deptName{
						color: #969696;
						margin-top: 6px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						max-width: 90px;
					}
					.el-icon-close{
						vertical-align: top;
					}
				}
			}
		}
		.ofooter{
			text-align: right;
		}
	}
}
</style>
